// Missing publication metadata must never reveal a freeform answer cloud.
// Older choice-poll payloads keep their established visible-by-default behavior.
export function pollResultsPublished(poll) {
  return String(poll?.kind || '').toLowerCase() === 'freeform'
    ? poll?.resultsVisible === true
    : poll?.resultsVisible !== false
}
